/* eslint-disable jsx-a11y/anchor-has-content */
import { SchedulingSettingsComponent } from 'app/components/scheduling-settings/SchedulingSettingsComponent'
import { useSchedulingSettings } from 'app/components/scheduling-settings/useSchedulingSettings'

export default function Settings() {
  const hookData = useSchedulingSettings()
  return <SchedulingSettingsComponent {...hookData} />
}
